<template>
  <div class="tab-bar">
    <div
      v-for="section in sections"
      :key="section.id"
      :class="['tab', { active: activeSection === section.id }]"
      @click="$emit('tab-change', section.id)"
    >
      {{ section.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "RecipeTabs",
  props: {
    sections: {
      type: Array,
      required: true,
    },
    activeSection: {
      type: String,
      required: true,
    },
  },
  emits: ["tab-change"],
};
</script>

<style scoped>
.tab-bar {
  position: sticky;
  top: 1px;
  z-index: 90;
  display: flex;
  background: var(--card-background);
  border-bottom: 1px solid var(--divider);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.tab-bar::-webkit-scrollbar {
  display: none;
}

.tab {
  flex: 1;
  min-width: max-content;
  padding: 16px;
  text-align: center;
  font-weight: 500;
  color: var(--text-secondary);
  border-bottom: 3px solid transparent;
  cursor: pointer;
}

.tab.active {
  color: var(--primary);
  border-bottom: 3px solid var(--primary);
}
</style>
